export default __webpack_public_path__ + "static/media/right_arrow_icon black.6b8266e6.svg";